export default "__VITE_ASSET__C9jg1sTm__"